import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: theme.spacing(3, 0, 2),
      height: 72,
    },
    childrenWrapper: {
      flex: 1,
    },
    title: {},
  }),
  { name: 'PageHeader' }
);
